module.exports = __webpack_public_path__ + "img/high-school-grade-en.5e40adb4.png";